/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const makeCsv = /* GraphQL */ `
  query MakeCsv($pk: String!, $list: [String]) {
    makeCsv(pk: $pk, list: $list) {
      statusCode
      result
    }
  }
`;
export const syncEqutServiceSettings = /* GraphQL */ `
  query SyncEqutServiceSettings(
    $filter: ModelEqutServiceSettingFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncEqutServiceSettings(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        iosMinVersion
        iosStoreUrl
        isMaintenance
        maintenanceText
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getEqutServiceSetting = /* GraphQL */ `
  query GetEqutServiceSetting($id: ID!) {
    getEqutServiceSetting(id: $id) {
      id
      iosMinVersion
      iosStoreUrl
      isMaintenance
      maintenanceText
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const listEqutServiceSettings = /* GraphQL */ `
  query ListEqutServiceSettings(
    $filter: ModelEqutServiceSettingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEqutServiceSettings(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        iosMinVersion
        iosStoreUrl
        isMaintenance
        maintenanceText
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncEqutWebSessions = /* GraphQL */ `
  query SyncEqutWebSessions(
    $filter: ModelEqutWebSessionFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncEqutWebSessions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        owner
        sessionId
        info
        _ttl
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getEqutWebSession = /* GraphQL */ `
  query GetEqutWebSession($owner: String!, $sessionId: String!) {
    getEqutWebSession(owner: $owner, sessionId: $sessionId) {
      id
      owner
      sessionId
      info
      _ttl
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const listEqutWebSessions = /* GraphQL */ `
  query ListEqutWebSessions(
    $owner: String
    $sessionId: ModelStringKeyConditionInput
    $filter: ModelEqutWebSessionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listEqutWebSessions(
      owner: $owner
      sessionId: $sessionId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        owner
        sessionId
        info
        _ttl
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncEqutSettings = /* GraphQL */ `
  query SyncEqutSettings(
    $filter: ModelEqutSettingFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncEqutSettings(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        tenantArn
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getEqutSetting = /* GraphQL */ `
  query GetEqutSetting($id: ID!) {
    getEqutSetting(id: $id) {
      id
      tenantArn
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const listEqutSettings = /* GraphQL */ `
  query ListEqutSettings(
    $filter: ModelEqutSettingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEqutSettings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        tenantArn
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getMCZV1 = /* GraphQL */ `
  query GetMCZV1($pk: String!, $sk: String!) {
    getMCZV1(pk: $pk, sk: $sk) {
      id
      pk
      sk
      lsiStr1
      lsiStr2
      lsiStr3
      lsiStr4
      lsiInt1
      createdUser
      updatedUser
      modifiedAd
      groups
      tenant {
        tenantId
        name
        contractStart
        contractEnd
        maxCapacity
        maxProjects
        maxFiles
        maxUsers
        maxItemLists
        status
        allocateVolume
        numberOfProject
        availableOptions
      }
      user {
        name
        userId
        usertype
        campanyName
        status
        period
        email
        deleted
      }
      meeting {
        title
        roomId
        meetingId
        startDateTime
        invitedUsers
      }
      project {
        id
        name
        description
        users {
          name
          userId
          usertype
          campanyName
          status
          period
          email
          deleted
        }
        members {
          userId
          authType
        }
      }
      rootItem {
        label
        id
        type
        path
        fileSize
      }
      treeData
      backImage {
        name
        filePath
        parameters
        inspectMasterId
        inspectMasterList
        lineSetting {
          streetlineId
          lineType
          startX
          startY
          endX
          endY
          lineColor
          lineWidth
          lineName
          labelPosition
        }
      }
      inspectPlace {
        placeId
        name
        x
        y
        createUser
        inspectMasterId
        lineName
        iconId
      }
      ttl
      shape {
        shapeId
        shapeType
        coordinates
        lineColor
        lineWidth
        paintColor
        paintAlpha
        radius
        shapeText
        shapeTextSize
        shapeTextColor
      }
      inspectMaster {
        id
        name
        statusName
        displayName
        description
        iconSelectType
        inspectItemList {
          id
          name
          itemType
          required
          order
          defaultValue
          systemDateFlg
          items {
            id
            name
            isDefault
            order
          }
        }
        iconSetting {
          id
          name
          iconFilePath
          order
          isDefault
        }
        lockFlg
        order
      }
      inspectResultSet {
        id
        masterId
        inspectList {
          itemId
          value
          valueId
          name
          itemType
          required
          order
        }
        photoList {
          filePath
          order
          isWrite
          memo
        }
      }
      notice {
        id
        targetUsers
        type
        title
        content
        Readed
        needPushNotice
        completedPush
        linkedId
        sourceName
      }
      timestamp
      treeItem {
        label
        id
        type
        path
        fileSize
      }
      recently {
        id
        targetSk
        treePlace
      }
      noticestatus {
        flg
      }
      noticeSegment {
        id
      }
      customize {
        key
        memo
      }
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const listMCZV1s = /* GraphQL */ `
  query ListMCZV1s(
    $pk: String
    $sk: ModelStringKeyConditionInput
    $filter: ModelMCZV1FilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listMCZV1s(
      pk: $pk
      sk: $sk
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        pk
        sk
        lsiStr1
        lsiStr2
        lsiStr3
        lsiStr4
        lsiInt1
        createdUser
        updatedUser
        modifiedAd
        groups
        tenant {
          tenantId
          name
          contractStart
          contractEnd
          maxCapacity
          maxProjects
          maxFiles
          maxUsers
          maxItemLists
          status
          allocateVolume
          numberOfProject
          availableOptions
        }
        user {
          name
          userId
          usertype
          campanyName
          status
          period
          email
          deleted
        }
        meeting {
          title
          roomId
          meetingId
          startDateTime
          invitedUsers
        }
        project {
          id
          name
          description
          users {
            name
            userId
            usertype
            campanyName
            status
            period
            email
            deleted
          }
          members {
            userId
            authType
          }
        }
        rootItem {
          label
          id
          type
          path
          fileSize
        }
        treeData
        backImage {
          name
          filePath
          parameters
          inspectMasterId
          inspectMasterList
          lineSetting {
            streetlineId
            lineType
            startX
            startY
            endX
            endY
            lineColor
            lineWidth
            lineName
            labelPosition
          }
        }
        inspectPlace {
          placeId
          name
          x
          y
          createUser
          inspectMasterId
          lineName
          iconId
        }
        ttl
        shape {
          shapeId
          shapeType
          coordinates
          lineColor
          lineWidth
          paintColor
          paintAlpha
          radius
          shapeText
          shapeTextSize
          shapeTextColor
        }
        inspectMaster {
          id
          name
          statusName
          displayName
          description
          iconSelectType
          inspectItemList {
            id
            name
            itemType
            required
            order
            defaultValue
            systemDateFlg
            items {
              id
              name
              isDefault
              order
            }
          }
          iconSetting {
            id
            name
            iconFilePath
            order
            isDefault
          }
          lockFlg
          order
        }
        inspectResultSet {
          id
          masterId
          inspectList {
            itemId
            value
            valueId
            name
            itemType
            required
            order
          }
          photoList {
            filePath
            order
            isWrite
            memo
          }
        }
        notice {
          id
          targetUsers
          type
          title
          content
          Readed
          needPushNotice
          completedPush
          linkedId
          sourceName
        }
        timestamp
        treeItem {
          label
          id
          type
          path
          fileSize
        }
        recently {
          id
          targetSk
          treePlace
        }
        noticestatus {
          flg
        }
        noticeSegment {
          id
        }
        customize {
          key
          memo
        }
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const listDataFromLsiStr1 = /* GraphQL */ `
  query ListDataFromLsiStr1(
    $pk: String
    $lsiStr1: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMCZV1FilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDataFromLsiStr1(
      pk: $pk
      lsiStr1: $lsiStr1
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        pk
        sk
        lsiStr1
        lsiStr2
        lsiStr3
        lsiStr4
        lsiInt1
        createdUser
        updatedUser
        modifiedAd
        groups
        tenant {
          tenantId
          name
          contractStart
          contractEnd
          maxCapacity
          maxProjects
          maxFiles
          maxUsers
          maxItemLists
          status
          allocateVolume
          numberOfProject
          availableOptions
        }
        user {
          name
          userId
          usertype
          campanyName
          status
          period
          email
          deleted
        }
        meeting {
          title
          roomId
          meetingId
          startDateTime
          invitedUsers
        }
        project {
          id
          name
          description
          users {
            name
            userId
            usertype
            campanyName
            status
            period
            email
            deleted
          }
          members {
            userId
            authType
          }
        }
        rootItem {
          label
          id
          type
          path
          fileSize
        }
        treeData
        backImage {
          name
          filePath
          parameters
          inspectMasterId
          inspectMasterList
          lineSetting {
            streetlineId
            lineType
            startX
            startY
            endX
            endY
            lineColor
            lineWidth
            lineName
            labelPosition
          }
        }
        inspectPlace {
          placeId
          name
          x
          y
          createUser
          inspectMasterId
          lineName
          iconId
        }
        ttl
        shape {
          shapeId
          shapeType
          coordinates
          lineColor
          lineWidth
          paintColor
          paintAlpha
          radius
          shapeText
          shapeTextSize
          shapeTextColor
        }
        inspectMaster {
          id
          name
          statusName
          displayName
          description
          iconSelectType
          inspectItemList {
            id
            name
            itemType
            required
            order
            defaultValue
            systemDateFlg
            items {
              id
              name
              isDefault
              order
            }
          }
          iconSetting {
            id
            name
            iconFilePath
            order
            isDefault
          }
          lockFlg
          order
        }
        inspectResultSet {
          id
          masterId
          inspectList {
            itemId
            value
            valueId
            name
            itemType
            required
            order
          }
          photoList {
            filePath
            order
            isWrite
            memo
          }
        }
        notice {
          id
          targetUsers
          type
          title
          content
          Readed
          needPushNotice
          completedPush
          linkedId
          sourceName
        }
        timestamp
        treeItem {
          label
          id
          type
          path
          fileSize
        }
        recently {
          id
          targetSk
          treePlace
        }
        noticestatus {
          flg
        }
        noticeSegment {
          id
        }
        customize {
          key
          memo
        }
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const listDataFromLsiStr2 = /* GraphQL */ `
  query ListDataFromLsiStr2(
    $pk: String
    $lsiStr2: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMCZV1FilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDataFromLsiStr2(
      pk: $pk
      lsiStr2: $lsiStr2
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        pk
        sk
        lsiStr1
        lsiStr2
        lsiStr3
        lsiStr4
        lsiInt1
        createdUser
        updatedUser
        modifiedAd
        groups
        tenant {
          tenantId
          name
          contractStart
          contractEnd
          maxCapacity
          maxProjects
          maxFiles
          maxUsers
          maxItemLists
          status
          allocateVolume
          numberOfProject
          availableOptions
        }
        user {
          name
          userId
          usertype
          campanyName
          status
          period
          email
          deleted
        }
        meeting {
          title
          roomId
          meetingId
          startDateTime
          invitedUsers
        }
        project {
          id
          name
          description
          users {
            name
            userId
            usertype
            campanyName
            status
            period
            email
            deleted
          }
          members {
            userId
            authType
          }
        }
        rootItem {
          label
          id
          type
          path
          fileSize
        }
        treeData
        backImage {
          name
          filePath
          parameters
          inspectMasterId
          inspectMasterList
          lineSetting {
            streetlineId
            lineType
            startX
            startY
            endX
            endY
            lineColor
            lineWidth
            lineName
            labelPosition
          }
        }
        inspectPlace {
          placeId
          name
          x
          y
          createUser
          inspectMasterId
          lineName
          iconId
        }
        ttl
        shape {
          shapeId
          shapeType
          coordinates
          lineColor
          lineWidth
          paintColor
          paintAlpha
          radius
          shapeText
          shapeTextSize
          shapeTextColor
        }
        inspectMaster {
          id
          name
          statusName
          displayName
          description
          iconSelectType
          inspectItemList {
            id
            name
            itemType
            required
            order
            defaultValue
            systemDateFlg
            items {
              id
              name
              isDefault
              order
            }
          }
          iconSetting {
            id
            name
            iconFilePath
            order
            isDefault
          }
          lockFlg
          order
        }
        inspectResultSet {
          id
          masterId
          inspectList {
            itemId
            value
            valueId
            name
            itemType
            required
            order
          }
          photoList {
            filePath
            order
            isWrite
            memo
          }
        }
        notice {
          id
          targetUsers
          type
          title
          content
          Readed
          needPushNotice
          completedPush
          linkedId
          sourceName
        }
        timestamp
        treeItem {
          label
          id
          type
          path
          fileSize
        }
        recently {
          id
          targetSk
          treePlace
        }
        noticestatus {
          flg
        }
        noticeSegment {
          id
        }
        customize {
          key
          memo
        }
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const listDataFromLsiStr3 = /* GraphQL */ `
  query ListDataFromLsiStr3(
    $pk: String
    $lsiStr3: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMCZV1FilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDataFromLsiStr3(
      pk: $pk
      lsiStr3: $lsiStr3
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        pk
        sk
        lsiStr1
        lsiStr2
        lsiStr3
        lsiStr4
        lsiInt1
        createdUser
        updatedUser
        modifiedAd
        groups
        tenant {
          tenantId
          name
          contractStart
          contractEnd
          maxCapacity
          maxProjects
          maxFiles
          maxUsers
          maxItemLists
          status
          allocateVolume
          numberOfProject
          availableOptions
        }
        user {
          name
          userId
          usertype
          campanyName
          status
          period
          email
          deleted
        }
        meeting {
          title
          roomId
          meetingId
          startDateTime
          invitedUsers
        }
        project {
          id
          name
          description
          users {
            name
            userId
            usertype
            campanyName
            status
            period
            email
            deleted
          }
          members {
            userId
            authType
          }
        }
        rootItem {
          label
          id
          type
          path
          fileSize
        }
        treeData
        backImage {
          name
          filePath
          parameters
          inspectMasterId
          inspectMasterList
          lineSetting {
            streetlineId
            lineType
            startX
            startY
            endX
            endY
            lineColor
            lineWidth
            lineName
            labelPosition
          }
        }
        inspectPlace {
          placeId
          name
          x
          y
          createUser
          inspectMasterId
          lineName
          iconId
        }
        ttl
        shape {
          shapeId
          shapeType
          coordinates
          lineColor
          lineWidth
          paintColor
          paintAlpha
          radius
          shapeText
          shapeTextSize
          shapeTextColor
        }
        inspectMaster {
          id
          name
          statusName
          displayName
          description
          iconSelectType
          inspectItemList {
            id
            name
            itemType
            required
            order
            defaultValue
            systemDateFlg
            items {
              id
              name
              isDefault
              order
            }
          }
          iconSetting {
            id
            name
            iconFilePath
            order
            isDefault
          }
          lockFlg
          order
        }
        inspectResultSet {
          id
          masterId
          inspectList {
            itemId
            value
            valueId
            name
            itemType
            required
            order
          }
          photoList {
            filePath
            order
            isWrite
            memo
          }
        }
        notice {
          id
          targetUsers
          type
          title
          content
          Readed
          needPushNotice
          completedPush
          linkedId
          sourceName
        }
        timestamp
        treeItem {
          label
          id
          type
          path
          fileSize
        }
        recently {
          id
          targetSk
          treePlace
        }
        noticestatus {
          flg
        }
        noticeSegment {
          id
        }
        customize {
          key
          memo
        }
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const listDataFromLsiStr4 = /* GraphQL */ `
  query ListDataFromLsiStr4(
    $pk: String
    $lsiStr4: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMCZV1FilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDataFromLsiStr4(
      pk: $pk
      lsiStr4: $lsiStr4
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        pk
        sk
        lsiStr1
        lsiStr2
        lsiStr3
        lsiStr4
        lsiInt1
        createdUser
        updatedUser
        modifiedAd
        groups
        tenant {
          tenantId
          name
          contractStart
          contractEnd
          maxCapacity
          maxProjects
          maxFiles
          maxUsers
          maxItemLists
          status
          allocateVolume
          numberOfProject
          availableOptions
        }
        user {
          name
          userId
          usertype
          campanyName
          status
          period
          email
          deleted
        }
        meeting {
          title
          roomId
          meetingId
          startDateTime
          invitedUsers
        }
        project {
          id
          name
          description
          users {
            name
            userId
            usertype
            campanyName
            status
            period
            email
            deleted
          }
          members {
            userId
            authType
          }
        }
        rootItem {
          label
          id
          type
          path
          fileSize
        }
        treeData
        backImage {
          name
          filePath
          parameters
          inspectMasterId
          inspectMasterList
          lineSetting {
            streetlineId
            lineType
            startX
            startY
            endX
            endY
            lineColor
            lineWidth
            lineName
            labelPosition
          }
        }
        inspectPlace {
          placeId
          name
          x
          y
          createUser
          inspectMasterId
          lineName
          iconId
        }
        ttl
        shape {
          shapeId
          shapeType
          coordinates
          lineColor
          lineWidth
          paintColor
          paintAlpha
          radius
          shapeText
          shapeTextSize
          shapeTextColor
        }
        inspectMaster {
          id
          name
          statusName
          displayName
          description
          iconSelectType
          inspectItemList {
            id
            name
            itemType
            required
            order
            defaultValue
            systemDateFlg
            items {
              id
              name
              isDefault
              order
            }
          }
          iconSetting {
            id
            name
            iconFilePath
            order
            isDefault
          }
          lockFlg
          order
        }
        inspectResultSet {
          id
          masterId
          inspectList {
            itemId
            value
            valueId
            name
            itemType
            required
            order
          }
          photoList {
            filePath
            order
            isWrite
            memo
          }
        }
        notice {
          id
          targetUsers
          type
          title
          content
          Readed
          needPushNotice
          completedPush
          linkedId
          sourceName
        }
        timestamp
        treeItem {
          label
          id
          type
          path
          fileSize
        }
        recently {
          id
          targetSk
          treePlace
        }
        noticestatus {
          flg
        }
        noticeSegment {
          id
        }
        customize {
          key
          memo
        }
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const listDataFromLsiInt1 = /* GraphQL */ `
  query ListDataFromLsiInt1(
    $pk: String
    $lsiInt1: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMCZV1FilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDataFromLsiInt1(
      pk: $pk
      lsiInt1: $lsiInt1
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        pk
        sk
        lsiStr1
        lsiStr2
        lsiStr3
        lsiStr4
        lsiInt1
        createdUser
        updatedUser
        modifiedAd
        groups
        tenant {
          tenantId
          name
          contractStart
          contractEnd
          maxCapacity
          maxProjects
          maxFiles
          maxUsers
          maxItemLists
          status
          allocateVolume
          numberOfProject
          availableOptions
        }
        user {
          name
          userId
          usertype
          campanyName
          status
          period
          email
          deleted
        }
        meeting {
          title
          roomId
          meetingId
          startDateTime
          invitedUsers
        }
        project {
          id
          name
          description
          users {
            name
            userId
            usertype
            campanyName
            status
            period
            email
            deleted
          }
          members {
            userId
            authType
          }
        }
        rootItem {
          label
          id
          type
          path
          fileSize
        }
        treeData
        backImage {
          name
          filePath
          parameters
          inspectMasterId
          inspectMasterList
          lineSetting {
            streetlineId
            lineType
            startX
            startY
            endX
            endY
            lineColor
            lineWidth
            lineName
            labelPosition
          }
        }
        inspectPlace {
          placeId
          name
          x
          y
          createUser
          inspectMasterId
          lineName
          iconId
        }
        ttl
        shape {
          shapeId
          shapeType
          coordinates
          lineColor
          lineWidth
          paintColor
          paintAlpha
          radius
          shapeText
          shapeTextSize
          shapeTextColor
        }
        inspectMaster {
          id
          name
          statusName
          displayName
          description
          iconSelectType
          inspectItemList {
            id
            name
            itemType
            required
            order
            defaultValue
            systemDateFlg
            items {
              id
              name
              isDefault
              order
            }
          }
          iconSetting {
            id
            name
            iconFilePath
            order
            isDefault
          }
          lockFlg
          order
        }
        inspectResultSet {
          id
          masterId
          inspectList {
            itemId
            value
            valueId
            name
            itemType
            required
            order
          }
          photoList {
            filePath
            order
            isWrite
            memo
          }
        }
        notice {
          id
          targetUsers
          type
          title
          content
          Readed
          needPushNotice
          completedPush
          linkedId
          sourceName
        }
        timestamp
        treeItem {
          label
          id
          type
          path
          fileSize
        }
        recently {
          id
          targetSk
          treePlace
        }
        noticestatus {
          flg
        }
        noticeSegment {
          id
        }
        customize {
          key
          memo
        }
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncMCZV1s = /* GraphQL */ `
  query SyncMCZV1s(
    $filter: ModelMCZV1FilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncMCZV1s(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        pk
        sk
        lsiStr1
        lsiStr2
        lsiStr3
        lsiStr4
        lsiInt1
        createdUser
        updatedUser
        modifiedAd
        groups
        tenant {
          tenantId
          name
          contractStart
          contractEnd
          maxCapacity
          maxProjects
          maxFiles
          maxUsers
          maxItemLists
          status
          allocateVolume
          numberOfProject
          availableOptions
        }
        user {
          name
          userId
          usertype
          campanyName
          status
          period
          email
          deleted
        }
        meeting {
          title
          roomId
          meetingId
          startDateTime
          invitedUsers
        }
        project {
          id
          name
          description
          users {
            name
            userId
            usertype
            campanyName
            status
            period
            email
            deleted
          }
          members {
            userId
            authType
          }
        }
        rootItem {
          label
          id
          type
          path
          fileSize
        }
        treeData
        backImage {
          name
          filePath
          parameters
          inspectMasterId
          inspectMasterList
          lineSetting {
            streetlineId
            lineType
            startX
            startY
            endX
            endY
            lineColor
            lineWidth
            lineName
            labelPosition
          }
        }
        inspectPlace {
          placeId
          name
          x
          y
          createUser
          inspectMasterId
          lineName
          iconId
        }
        ttl
        shape {
          shapeId
          shapeType
          coordinates
          lineColor
          lineWidth
          paintColor
          paintAlpha
          radius
          shapeText
          shapeTextSize
          shapeTextColor
        }
        inspectMaster {
          id
          name
          statusName
          displayName
          description
          iconSelectType
          inspectItemList {
            id
            name
            itemType
            required
            order
            defaultValue
            systemDateFlg
            items {
              id
              name
              isDefault
              order
            }
          }
          iconSetting {
            id
            name
            iconFilePath
            order
            isDefault
          }
          lockFlg
          order
        }
        inspectResultSet {
          id
          masterId
          inspectList {
            itemId
            value
            valueId
            name
            itemType
            required
            order
          }
          photoList {
            filePath
            order
            isWrite
            memo
          }
        }
        notice {
          id
          targetUsers
          type
          title
          content
          Readed
          needPushNotice
          completedPush
          linkedId
          sourceName
        }
        timestamp
        treeItem {
          label
          id
          type
          path
          fileSize
        }
        recently {
          id
          targetSk
          treePlace
        }
        noticestatus {
          flg
        }
        noticeSegment {
          id
        }
        customize {
          key
          memo
        }
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
